import {
  createDictionaryLexiconFromWordList,
  type DictionaryLexicon,
} from '../core/dictionary'

import lexiconWordsUrl from '../../content/lexicon.words.json?url'

/** Emitted as a content-hashed asset in production builds (not inlined). */
const WORDS_URL = lexiconWordsUrl

let impl: DictionaryLexicon | null = null
let inflight: Promise<void> | null = null

const emptyLexicon = createDictionaryLexiconFromWordList([])

/**
 * Stable reference for the engine: `getBoardWord` works before load; `isDictionaryWord`
 * is false until `loadStandardDictionaryLexicon()` completes (unless `primeStandardLexicon` ran).
 */
export const standardLexicon: DictionaryLexicon = {
  getBoardWord(board, selection) {
    return (impl ?? emptyLexicon).getBoardWord(board, selection)
  },
  isDictionaryWord(word) {
    if (!impl) {
      return false
    }
    return impl.isDictionaryWord(word)
  },
}

export function isStandardDictionaryLoaded(): boolean {
  return impl !== null
}

/** Test-only: inject the full word list without a network request. */
export function primeStandardLexicon(lexicon: DictionaryLexicon): void {
  impl = lexicon
}

/** Fetches the word list (not bundled). Safe to call multiple times. */
export function loadStandardDictionaryLexicon(): Promise<void> {
  if (impl) {
    return Promise.resolve()
  }
  inflight ??= fetch(WORDS_URL)
    .then(response => {
      if (!response.ok) {
        throw new Error(
          `[boggle] ${WORDS_URL} → ${response.status}. Run: bun scripts/generate-boggle-lexicon.ts`,
        )
      }
      return response.json() as Promise<{ uniqueWords: string[] }>
    })
    .then(data => {
      impl = createDictionaryLexiconFromWordList(data.uniqueWords)
    })
    .finally(() => {
      inflight = null
    })
  return inflight
}
